import styled from "@emotion/styled";
import PropTypes from "prop-types";
import React from "react";

import { getCurrentDate } from "~/utilities/formatDates";

import useStringTranslation from "~/hooks/translations/useStringTranslation";

const Flag = styled.div`
    width: ${({ isComingSoon }) => (isComingSoon ? `85px` : `55px`)};
    height: ${({ isComingSoon }) => (isComingSoon ? `25px` : `20px`)};
    background-color: ${({ theme }) => theme.palette.black};
    color: ${({ theme }) => theme.palette.white};
    display: flex;
    flex-direction: ${({ isComingSoon }) => (isComingSoon ? `column` : `row`)};
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 1rem;
    padding: ${({ isComingSoon }) => (isComingSoon ? `0 10px 0 5px` : `0 5px`)};
    text-transform: uppercase;
    margin-left: 10px;
    clip-path: polygon(0% 0%, 100% 0, 90% 50%, 100% 100%, 0% 100%);
`;

const checkDate = (date, dateType) => {
    if (!date) return false;

    const targetDate = new Date(Date.parse(date));
    const today = new Date(Date.parse(getCurrentDate()));

    switch (dateType) {
        case "after":
            return today > targetDate;
        default:
            return today < targetDate;
    }
};

const ProductFlag = ({ badgeName, dateType, date }) => {
    const displayFlag = checkDate(date, dateType);

    const isComingSoon = badgeName === "comingSoon";

    const { comingSoonText, newText } = useStringTranslation([
        { text: "Coming Soon", handle: "comingSoonText" },
        { text: "New", handle: "newText" },
    ]);

    const flagLabel = isComingSoon ? comingSoonText : newText;
    const flagLabels = flagLabel.split(" ");

    return displayFlag ? (
        <Flag {...{ isComingSoon }}>
            {flagLabels.map((label, index) => (
                <div key={`pf-${label}-${index}`}>{label}</div>
            ))}
        </Flag>
    ) : null;
};

ProductFlag.propTypes = {
    badgeName: PropTypes.oneOf(["new", "comingSoon"]).isRequired,
    dateType: PropTypes.oneOf(["until", "after"]).isRequired,
    date: PropTypes.string,
};

export default ProductFlag;
